import { Session } from '@supabase/supabase-js'
import { createContext } from 'react'

export interface MainContextType {
  session: Session | null
  isAdmin: boolean
}

export const MainContext = createContext<MainContextType | undefined>(undefined)
